// extracted by mini-css-extract-plugin
export default {"main":"styles_main__lnkkK","container":"styles_container__tkzPn","my_project_content":"styles_my_project_content__koD7O"};